document.querySelector("#CartDrawer").addEventListener("click", (e) => {
  if(e.target.classList.contains("upsale-card__add-btn")) {
    if(e.target.getAttribute('aria-disabled')  === 'true') return;

    e.target.setAttribute('aria-disabled', true);
    e.target.classList.add('loading');
    let variants = JSON.parse(e.target.closest(".upsale-card__content").querySelector("script").innerHTML);
    let selectedOptions = e.target.closest(".upsale-card__content").querySelectorAll("select option:checked");
    if(window.innerWidth < 750){
      variants = JSON.parse(e.target.closest(".mobile .upsale-card__content").querySelector("script").innerHTML);
      selectedOptions = e.target.closest(".mobile .upsale-card__content").querySelectorAll("select option:checked");
    }

    let titleForCompare = '';
    let variantid = 0;

    selectedOptions.forEach((option, i) => {
      if (i == selectedOptions.length - 1) {
        titleForCompare += option.dataset.value;
      } else {
        titleForCompare += option.dataset.value + " / ";
      }
    });

    variants.forEach(variant => {
      if(variant.title == titleForCompare) {
        variantid = variant.id;
      }
    })

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    let formData = {
      'items': [
        {
          "id": variantid,
          "quantity": 1,
        }
      ],
      'sections': cart.getSectionsToRender().map((section) => section.id)
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((response) => response.json()).then(response => {
      cart.renderContents(response)
    })
  } else if (e.target.classList.contains("ts-controll")) {
    const slidesElemth = document.querySelectorAll(".mobile .ts-upsale__cards li");
    let slidesLength = slidesElemth.length;

    slidesLength = slidesElemth.length;

    const currentSlide = parseInt(document.querySelector(".mobile.ts-upsale").dataset.slide);
    if (e.target.classList.contains("ts-controll--right") && currentSlide < (slidesLength)) {
      const slide = document.querySelector(`.mobile .ts-upsale__cards li:nth-of-type(${currentSlide + 1})`);
      slide.scrollIntoView({ inline: "start", behavior: "smooth", block: "nearest" });
      document.querySelector(".mobile.ts-upsale").setAttribute("data-slide", `${currentSlide + 1}`);
    } else if (e.target.classList.contains("ts-controll--left") && currentSlide > 1) {
      const slide = document.querySelector(`.mobile .ts-upsale__cards li:nth-of-type(${currentSlide - 1})`);
      slide.scrollIntoView({ inline: "start", behavior: "smooth", block: "nearest" });
      document.querySelector(".mobile.ts-upsale").setAttribute("data-slide", `${currentSlide - 1}`);
    }
    const currentSlideNew = parseInt(document.querySelector(".mobile.ts-upsale").dataset.slide);
    const leftArrow = document.querySelector(".mobile .ts-controll--left");
    const rightArrow = document.querySelector(".mobile .ts-controll--right");
    console.log(currentSlideNew);
    if (currentSlideNew === 1) {
      leftArrow.style.opacity = 0;
    } else {
      leftArrow.style.opacity = 1;
    }
    
    if (currentSlideNew === slidesLength) {
      rightArrow.style.opacity = 0;
    } else {
      rightArrow.style.opacity = 1;
    }
  } else if (e.target.hasAttribute("for") && e.target.getAttribute("for") === "coupons_stacker_input") {
    e.preventDefault();

    const drawerFooter = e.target.closest(".cart-drawer__footer");
    if (!drawerFooter) return;
      
    if (drawerFooter.hasAttribute("open")) {
      drawerFooter.removeAttribute("open")
    } else {
      drawerFooter.setAttribute("open", true);
    }
  }
});